export default __webpack_public_path__ + "static/desktopApp-c81b43693f363de5726bd13e65dafb6c.jpg";